// extracted by mini-css-extract-plugin
export var footerEven = "footer-module--footerEven--+XyMo";
export var footerOdd = "footer-module--footerOdd--uiIWt";